"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEventSource = void 0;
function getEventSource() {
    return typeof EventSource === 'function' ? EventSource : undefined;
}
exports.getEventSource = getEventSource;
